import {useMutation, gql} from '@apollo/client'

export const createProj = gql`
  mutation createProj(
    $clientId: Alphanumeric!
    $groupName: Customname!
    $groupType: Alphanumeric!
    $description: AlphanumericOrEmpty
    $filters: [String]
    $dataAggregation: [Int]
    $jurisdiction: [Int]
    $trendAnalysisFlag: [Int]
    $chatbotFlag: [Int]
    $chatbotExportFlag: [Int]
    $chatbotCopyFlag: [Int]
    $exportFlag: [Int]
    $benefits: [Int]
    $workforces: [Int]
    $usecase: [Int]
    $pointOfInterest: [Int]
    $personaFlag: [Int]
  ) {
    creategroup(
      groupName: $groupName
      groupType: $groupType
      clientId: $clientId
      description: $description
      filters: $filters
      dataAggregation: $dataAggregation
      jurisdiction: $jurisdiction
      trendAnalysisFlag: $trendAnalysisFlag
      chatbotFlag: $chatbotFlag
      exportFlag: $exportFlag
      benefits: $benefits
      workforces: $workforces
      usecase: $usecase
      pointOfInterest: $pointOfInterest
      personaFlag: $personaFlag
      chatbotExportFlag: $chatbotExportFlag
      chatbotCopyFlag: $chatbotCopyFlag
    ) {
      userGroup {
        group_name
        group_type
        group_id
        client_id
        description
        filters
        data_aggregation
        jurisdiction
        is_completed
        trend_analysis_flag
        chatbot_flag
        export_flag
        benefits
        workforces
        usecase
        point_of_interest
        persona_flag
        chatbot_export_flag
        chatbot_copy_flag
      }
    }
  }
`
export function useCreateProjectDetails() {
  return useMutation(createProj, {
    context: {clientName: 'adminPanel'}
  })
}
